function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.42969 4H12.5703C13.3672 4 14 4.65625 14 5.42969C14 5.45312 14 5.47656 14 5.5V11.5C14 12.3203 13.3203 13 12.5 13H3.5C2.67969 13 2 12.3203 2 11.5V5.5C2 5.47656 2 5.45312 2 5.42969C2 4.65625 2.65625 4 3.42969 4ZM12.875 7L9.24219 9.76562C8.51562 10.3281 7.48438 10.3281 6.75781 9.76562L3.125 7V11.5C3.125 11.7109 3.28906 11.875 3.5 11.875H12.5C12.7109 11.875 12.875 11.7109 12.875 11.5V7ZM3.125 5.42969C3.125 5.54688 3.17188 5.64062 3.24219 5.6875L7.4375 8.875C7.76562 9.10938 8.23438 9.10938 8.5625 8.875L12.7578 5.6875C12.8281 5.64062 12.875 5.54688 12.875 5.42969C12.875 5.26562 12.7344 5.125 12.5703 5.125H3.42969C3.26562 5.125 3.125 5.26562 3.125 5.42969Z",
  fill: "currentColor"
});

function SvgPhishingIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhishingIcon);
export default __webpack_public_path__ + "static/media/phishing-icon.29cb8d67.svg";
export { ForwardRef as ReactComponent };